import { PlayerRef } from '@remotion/player';
import { renderFrame } from '../utils/render-frame';
import { useTimelinePosition } from '../utils/use-timeline-position';

export function CurrentTimeDisplay({
  playerRef,
  fps,
}: {
  playerRef: React.RefObject<PlayerRef | null>;
  fps: number;
}) {
  const currentFrame = useTimelinePosition({ playerRef });

  return (
    <div
      title="Current time"
      className="text-comp-accent-small text-sys-cont-neutral-default"
    >
      {renderFrame(currentFrame, fps)}
    </div>
  );
}
